import { render, staticRenderFns } from "./Toogle2.vue?vue&type=template&id=8b280360&scoped=true&"
import script from "./Toogle2.vue?vue&type=script&lang=js&"
export * from "./Toogle2.vue?vue&type=script&lang=js&"
import style0 from "./Toogle2.vue?vue&type=style&index=0&id=8b280360&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b280360",
  null
  
)

export default component.exports